import { useSelector } from 'react-redux'
import { Outlet, useSearchParams } from 'react-router-dom'

import { TopAreaNavigation } from 'infrastructure/Application/components'
import apiAsync from 'infrastructure/shared/api/api-async'
import { defaultLanguage } from 'locales'
import { useTranslation } from 'react-i18n-lite'

type ReduxState = { authentication: { token: string } }

const PrivateRoutes = () => {
  const [searchParams] = useSearchParams()
  const { language } = useTranslation()
  const tokenState = useSelector(
    (state: ReduxState) => state.authentication.token
  )

  const tokenUrl = searchParams.get('token')

  apiAsync.setAuthToken(tokenUrl || tokenState)

  if (!tokenUrl && !tokenState) {
    const loginUrl = new URL('login', window.waAuthenticationUrl)
    const redirectUrl = new URL(window.location.href)

    loginUrl.searchParams.set('lang', language || defaultLanguage)
    loginUrl.searchParams.set('redirectOrigin', redirectUrl.toString())

    window.location.assign(loginUrl.toString())
  }

  return (
    <>
      <TopAreaNavigation />
      <Outlet />
    </>
  )
}

export default PrivateRoutes
